// Plugin docs https://air-datepicker.com/ru/examples

import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';
// import localeEn from 'air-datepicker/locale/en';

new AirDatepicker('#calendar-datepicker', {
  inline: true,
  locale: {
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    daysMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    today: 'Today',
    clear: 'Clear',
    dateFormat: 'MM/dd/yyyy',
    timeFormat: 'hh:mm aa',
    firstDay: 0,
  },
  navTitles: {
    days: 'MMMM yyyy',
  },
  prevHtml: '<span class="ui-icon ui-icon-circle-triangle-w">Prev</span>',
  nextHtml: '<span class="ui-icon ui-icon-circle-triangle-e">Next</span>',
});

// You can use event onSelect ({date, formattedDate, datepicker})
// to track user date input
// https://air-datepicker.com/docs
